/**
 * 360 Resto Mark — Apple-style refined logomark.
 *
 * A minimalist app-icon style symbol:
 *   - Rounded square container with a subtle soft inner edge
 *   - "360" centered in SF Mono numeric, no degree symbol
 *   - Single hairline accent at the bottom (a "horizon line")
 *   - Available in 2 tones: light (for cream/white bg) | dark (for dark surface)
 *
 * Props:
 *   - size: pixel size (default 40)
 *   - tone: "light" (white tile, dark numerals) | "dark" (ink tile, light numerals)
 *   - withShadow: subtle elevation shadow (default false)
 */
const Resto360Mark = ({
  size = 40,
  tone = 'light',
  withShadow = false,
  className = '',
  ...rest
}) => {
  const isLight = tone === 'light';
  const tileBg = isLight ? '#FFFFFF' : '#1D1D1F';
  const numColor = isLight ? '#1D1D1F' : '#F5F5F7';
  const accent = '#FF5A1F';
  const tileStroke = isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.10)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="resto360-mark"
      style={{ filter: withShadow ? 'drop-shadow(0 4px 12px rgba(0,0,0,0.10))' : undefined }}
      aria-label="360 Resto"
      {...rest}
    >
      {/* Rounded square tile (Apple app-icon proportions: ~22% radius) */}
      <rect x="1" y="1" width="62" height="62" rx="14" fill={tileBg} stroke={tileStroke} strokeWidth="1" />

      {/* "360" centered SF Mono */}
      <text
        x="32"
        y="38"
        textAnchor="middle"
        fontFamily="ui-monospace, 'SF Mono', 'IBM Plex Mono', monospace"
        fontWeight="600"
        fontSize="20"
        fill={numColor}
        letterSpacing="0.5"
      >
        360
      </text>

      {/* Single orange hairline accent (the "horizon") at the bottom */}
      <rect x="22" y="48" width="20" height="1.5" rx="0.75" fill={accent} />
    </svg>
  );
};

export default Resto360Mark;
